import { Sidebar_Tools as Alexandria_Sidebar_Tools, Sidebar_Tools_Registry } from "monica-alexandria";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
const clients = require("../../config/index").config;

export default function Sidebar_Tools(props) {
  const navigate = useNavigate();
  const { lang } = useParams();

  return (
    <Alexandria_Sidebar_Tools
      toolsTitle={props.toolsTitle}
      variant={props.variant || "tools"}
      visibleKeys={props.visibleKeys || Sidebar_Tools_Registry.tools.filter(app => app.key !== "verdict").map(app => app.key)}
      currentAppKey="niffler"
      routeLanguage={lang || "en"}
      baseUrls={clients}
      itemState={clients.artist ? { artist: { url: `${clients.artist.replace(/\/+$/, "")}/${lang || "en"}/post-library` } } : undefined}
      localRoutes={{ niffler: `/${lang || "en"}/crm` }}
      sidebar={props.sidebar}
      expand={props.sidebar}
      compact={!props.sidebar}
      showSeparator={props.showSeparator}
      comingSoonLabel={t("Coming soon")}
      translate={t}
      onInternalNavigate={navigate}
    ></Alexandria_Sidebar_Tools>
  );
}

export { Sidebar_Tools };
